import { MakeCall } from 'ha/services/apiV2/createMakeCall';

interface Payload {
  listingId: number;
  targetLang: string;
  translator?: 'google' | 'deepl';
}

export interface ListingTranslationResponse {
  description: string;
}

export default (makeCall: MakeCall) =>
  ({ listingId, targetLang, translator }: Payload) =>
    makeCall<ListingTranslationResponse>(
      'GET',
      `/api/v2/listing/${listingId}/translate/description/${targetLang}`,
      {
        query: {
          translator,
        },
      },
    );
